<template>

    <v-dialog v-model="model"
              persistent
              max-width="1000">

        <v-card color="grey darken-2" :loading="processing">

            <toolbar-page title="Disqualify participants" icon="mdi-account-group"
                          help="project-disqualify-participants"
                          color="#252525">
                <template slot="buttons">

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="close()"
                                   v-on="on"
                                   icon>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close this dialog</span>
                    </v-tooltip>
                </template>
            </toolbar-page>

            <v-card-text>

                <!-- BEFORE SUBMIT -->
                <div v-if="!submitted">

                    <div class="d-flex mt-5">
                        <v-select
                            v-model="typeModel"
                            :items="typeItems"
                            label="Select disqualification reason"
                            style="max-width: 300px"
                        ></v-select>

                        <div class="flex-grow-0 align-self-center ml-10">
                        <v-alert type="info" dense class="body-2">
                            Paste up to 1000 panelist identifiers into the box below
                        </v-alert>
                        </div>
                    </div>

                    <identifiers-paste-box v-if="!submitted"
                                           :show-confirm-button="true"
                                           confirm-button-text="Confirm"
                                           @confirm="identifiersPasted"
                    ></identifiers-paste-box>
                </div>

                <!-- RESULTS SCREEN -->
                <div v-show="submitted" class="pt-4">

                    <div class="d-flex" v-show="submitted">
                        <div style="width: 250px;">
                            <stat-box-numerical color="success" :value="updatedCount" :loading="processing"
                                                hint="Updated count"/>
                        </div>
                        <div style="width: 250px;" class="pl-2">
                            <stat-box-numerical color="error" :loading="processing" :value="invalidCount"
                                                hint="Invalid count"/>
                        </div>
                    </div>

                    <v-alert v-show="invalidCount > 0" type="warning" icon="mdi-alert" class="mt-2 mb-2 body-2">
                        Server rejected the following identifiers. Either panelist was not found or does not have <b>completed</b> -status.
                    </v-alert>

                    <v-textarea class="mt-2 monospace"
                                spellcheck="false"
                                hide-details
                                solo
                                rows="10"
                                v-model="serverErrorsModel"
                    ></v-textarea>

                    <v-btn color="primary" class="mt-3" v-show="close" @click="doneClicked">Done</v-btn>
                    <v-btn color="primary" text class="mt-3" v-show="submitted" @click="resetClicked">Reset</v-btn>

                </div>

            </v-card-text>
        </v-card>

    </v-dialog>

</template>

<script>

import ToolbarPage from "../../../components/UI/ToolbarPage";
import {mapActions} from 'vuex';
import Json from 'vue-json-pretty';
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";
import ChartLoader from "../../../components/UI/ChartLoader";
import IdentifiersPasteBox from "../../../components/UI/IdentifiersPasteBox";
import StatBoxNumerical from "../../../components/UI/StatBoxNumerical";

export default {

    mixins: [timeDisplay],

    name: "DisqualifyDialog",

    components: {
        StatBoxNumerical,
        ChartLoader,
        Json,
        ToolbarPage,
        IdentifiersPasteBox
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },

        project: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            typeModel: 'quality',
            invalidCount: 0,
            updatedCount: 0,
            submitted: false,
            processing: false,
            serverErrorsModel: [],
            typeItems: [
                {text: "Quality", value: "quality"},
                {text: "Duplicate", value: "duplicate"}
            ]
        }
    },

    computed: {

        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.close(value);
            }
        },
    },

    methods: {

        ...mapActions('ProjectManager', [
            'disqualifyParticipants'
        ]),

        identifiersPasted(identifiers) {
            this.disqualify(identifiers);
        },

        disqualify(panelistIds) {

            this.processing = 'primary';
            this.submitted = true;

            const config = {
                projectId: this.project.id,
                reason: this.typeModel,
                panelistIds: panelistIds
            }

            this.disqualifyParticipants(config)
                .then((response) => {
                    this.updatedCount = response.data.updated_count;
                    this.invalidCount = response.data.invalid_count;
                    this.serverErrorsModel = response.data.invalid_identifiers.join("\n");
                })
                .catch((error) => {
                    Bus.$emit('flash-message', {type: "error", message: "OOPS We failed to disqualify"});
                })
                .finally(() => {
                    this.processing = false;
                })
        },

        resetClicked() {
            this.submitted = false;
            this.serverErrorsModel = [];
            this.updatedCount = 0;
            this.invalidCount = 0;
        },

        doneClicked() {
            this.resetClicked();
            this.close();
        },

        close() {
            this.$emit('input', false);
        }
    },

}
</script>


<style scoped>

.monospace {
    font-family: "Lucida Console", Courier, monospace !important;
    font-size: 1.1em !important;
}

</style>
